import { css } from '@emotion/core'
import { Flow, Heading, Text } from 'bold-ui'
import { ReactNode } from 'react'

import { HistoricoMChatPerguntaSection } from './components/HistoricoMchatPerguntaSection'

interface HistoricoMChatResultadoProps {
  title: string
  label: string
  encaminhamento: ReactNode
  titleColor: string
}

export function HistoricoMChatResultado(props: Readonly<HistoricoMChatResultadoProps>) {
  const { title, label, encaminhamento, titleColor } = props

  return (
    <HistoricoMChatPerguntaSection>
      <Flow direction='vertical' gap={0.5} justifyItems='stretch'>
        <Heading level={4}>Resultado:</Heading>
        <Heading level={3}>
          <Text style={styles.title(titleColor)}>{title}</Text>
          <Text style={styles.label}> | {label}</Text>
        </Heading>
        <Flow direction='vertical' gap={0} justifyItems='stretch'>
          <Heading level={5}>Encaminhamento</Heading>
          <Text style={styles.encaminhamento}>{encaminhamento}</Text>
        </Flow>
      </Flow>
    </HistoricoMChatPerguntaSection>
  )
}

const styles = {
  title: (color: string) => css`
    color: ${color};
    font-size: inherit;
  `,
  label: css`
    font-size: inherit;
    font-weight: normal;
  `,
  encaminhamento: css`
    & span,
    & strong {
      font-weight: normal;
    }
  `,
}
